







































































































































import Vue from "vue";
import moment from "moment";
import { mapState, mapGetters } from "vuex";
import AddPriority from "./add-priority.vue";
import UserAvatar from "../common/user-avatar.vue";
import SimpleProgress from "../common/simple-progress.vue";
import { on } from "iview/src/utils/dom";
import Util from "../../lib/util";

export default Vue.extend({
  name: "PriorityList",
  components: { AddPriority, UserAvatar, SimpleProgress },
  props: {
    member: Object,
  },
  data() {
    let context = this as any;
    return {
      showAddPriority: false,
      mediaMatched: null,
      settingCount: 0,
      showColumnSetup: false,
      dynamicColumnSettings: ["name", "progress", "state"],
      dynamicColumns: [
        {
          title: "NAME",
          key: "name",
          slot: "name",
          minWidth: 200,
          className: "priority-name",
          sortable: true,
        },
        {
          title: "PROGRESS",
          key: "progress",
          slot: "progress",
          sortable: true,
          minWidth: 120,
        },
        {
          title: "USERS",
          key: "users",
          slot: "users",
          minWidth: 200,
        },
        {
          title: "TAGS",
          key: "tags",
          slot: "tags",
          minWidth: 200,
        },
        {
          title: "STATE",
          key: "state",
          slot: "state",
          sortable: true,
          minWidth: 120,
        },
        {
          title: "ROLE",
          key: "roleName",
          slot: "roleName",
          minWidth: 120,
          sortable: true,
          filters: context.getRoleFilterOptions(),
          filterMultiple: false,
          filterMethod(value, row) {
            return row.roleName === value;
          },
        },
        {
          title: "LAST ACTIVE",
          slot: "last-active",
          sortable: true,
          width: 180,
          align: "center",
        },
      ],
    };
  },
  computed: {
    ...mapState("billing", ["loading", "billingAccount", "currentMemberJoinedGroups"]),
    ...mapGetters("billing", ["hasUserManagementPermission"]),
    columns() {
      let context = this as any;
      context.settingCount; // force recomputing

      let result: Array<any> = [
        {
          title: "TYPE",
          key: "type",
          slot: "type",
          sortable: true,
          width: 110,
          filters: [
            {
              label: "Team",
              value: "Team",
            },
            {
              label: "Target",
              value: "Target",
            },
            {
              label: "Project",
              value: "Project",
            },
            {
              label: "Review",
              value: "Review",
            },
          ],
          filterMultiple: false,
          filterMethod(value, row) {
            return row.type === value;
          },
        },
      ];

      let settings = context.dynamicColumnSettings;
      let firstColumn = context.getDynamicColumn(settings[0]);
      firstColumn.align = "left";
      result.push(firstColumn);

      if (context.mediaMatched === false) {
        result.push(context.getDynamicColumn(settings[1]));
        result.push(context.getDynamicColumn(settings[2]));
      }
      result = result.concat([
        {
          title: "STATUS",
          slot: "status",
          width: 120,
          align: "center",
          sortable: true,
          filters: [
            {
              label: "Active",
              value: "Active",
            },
            {
              label: "Completed",
              value: "Completed",
            },
          ],
          filterMultiple: false,
          filterMethod(value, row) {
            return row.status === value;
          },
        },
      ]);

      if (context.hasUserManagementPermission) {
        result.push({
          title: "EDIT",
          key: "id",
          slot: "edit",
          width: 80,
          align: "center",
        });
      }

      return result;
    },
    joinedGroups() {
      let context = this as any;
      let groups = context.currentMemberJoinedGroups || [];

      return groups.map((group) => {
        return Object.assign({}, group, {
          tags: group.hashTags ? JSON.parse(group.hashTags) : [],
          completedPercentage: group.completedPercentage ? Math.round(group.completedPercentage) : NaN,
        });
      });
    },
    joinedTeams() {
      let context = this as any;
      let groups = context.joinedGroups || [];

      return groups.filter((g) => g.type == "Team");
    },
    joinedTargets() {
      let context = this as any;
      let groups = context.joinedGroups || [];

      return groups.filter((g) => g.type == "Target");
    },
    joinedProjects() {
      let context = this as any;
      let groups = context.joinedGroups || [];

      return groups.filter((g) => g.type == "Project");
    },
    joinedReviews() {
      let context = this as any;
      let groups = context.joinedGroups || [];

      return groups.filter((g) => g.type == "Review");
    },
  },
  watch: {},
  mounted() {
    let abp = Util.abp;
    this.dynamicColumnSettings = abp.setting && abp.setting.values ? JSON.parse(abp.setting.values["App.MyUserPriorityListColumns"]) : ["name", "type", "users"];

    on(window, "resize", this.onWindowResize);
    this.matchMedia();
  },
  methods: {
    matchMedia() {
      let matchMedia;
      if (window.matchMedia) {
        matchMedia = window.matchMedia;
      }

      this.mediaMatched = matchMedia("(max-width: 992px)").matches;
    },
    getRoleFilterOptions() {
      let groups = (this as any).joinedGroups ? (this as any).joinedGroups : [];

      return [...new Set(groups.map((g) => g.roleName))]
        .sort((a, b) => {
          return a == b ? 0 : a > b ? 1 : -1;
        })
        .map((roleName) => {
          return {
            label: roleName,
            value: roleName,
          };
        });
    },
    onWindowResize() {
      this.matchMedia();
    },
    getDynamicColumn(key) {
      let columns = this.dynamicColumns.filter((column) => {
        return column.key == key;
      });

      if (columns.length == 1) {
        return Object.assign(columns[0], { renderHeader: this.renderHeader, align: "left" });
      } else {
        return null;
      }
    },
    renderHeader(h, params) {
      let context = this as any;
      return h("span", {}, [
        h("span", params.column.title),
        h(
          "Poptip",
          {
            props: {
              value: context.showColumnSetup,
              placement: "bottom",
              transfer: true,
              width: "196px",
              trigger: "click",
              offset: 3,
              "popper-class": "ivu-table-popper",
            },
            style: {
              "font-weight": "400",
            },
            ref: "ColumnSetup",
            refInFor: true,
          },
          [
            h("Icon", {
              props: {
                type: "md-settings",
                color: "#B9BCCD",
                size: "12",
              },
              style: {
                "margin-left": "4px",
              },
            }),
            h(
              "div",
              {
                slot: "content",
                class: "", // 调整datepicker样式
              },
              [
                h(
                  "CellGroup",
                  {
                    on: {
                      "on-click": function (name) {
                        let components = context.$refs.PriorityTable.$children.filter((child) => child.$refs.ColumnSetup);
                        if (components.length == 1) {
                          components[0].$refs.ColumnSetup.forEach((poptip) => {
                            if (poptip.visible === true) {
                              poptip.handleClose();
                            }
                          });
                        }

                        let index = context.dynamicColumnSettings.indexOf(params.column.key);
                        context.dynamicColumnSettings[index] = name;
                        context.showColumnSetup = false;
                        context.settingCount++;

                        context.changeMyUserPriorityListColumns();
                      },
                    },
                  },
                  [
                    context.dynamicColumns.map((column) => {
                      return h("Cell", {
                        props: {
                          title: column.title,
                          name: column.key,
                          selected: column.key == params.column.key,
                          disabled: column.key !== params.column.key && context.dynamicColumnSettings.indexOf(column.key) >= 0,
                        },
                        style: {
                          "text-left": "left",
                        },
                      });
                    }),
                  ]
                ),
              ]
            ),
          ]
        ),
      ]);
    },
    changeMyUserPriorityListColumns() {
      this.$store.dispatch("billing/changeMyUserPriorityListColumns", { model: JSON.stringify(this.dynamicColumnSettings) }).then((response) => {
        if (response.data && response.data.success === true) {
          Util.abp.setting.values["App.MyUserPriorityListColumns"] = JSON.stringify(this.dynamicColumnSettings);
        }
      });
    },
    getDateText(date) {
      return date ? moment(date).format("MMM D, YYYY hh:mm a") : "";
    },
    handleMenuItemClick(name, user) {
      switch (name) {
        case "remove":
          this.removePriority(user);
          break;
        case "delete":
          break;
      }
    },
    removePriority(joinedGroup) {
      let context = this as any;
      this.$Modal.confirm({
        title: "Remove",
        content: "<p>Are you sure you want to remove the user?</p>",
        onOk: () => {
          let actionName = "";
          let data = {};
          if (joinedGroup.type === "Target") {
            actionName = "goal/removeMember";
            data = {
              memberId: context.member.memberId,
              goalId: joinedGroup.id,
            };
          } else if (joinedGroup.type === "Project") {
            actionName = "project/removeMember";
            data = {
              memberId: context.member.memberId,
              projectId: joinedGroup.id,
            };
          }

          this.$store
            .dispatch(actionName, {
              data: data,
            })
            .then(() => {
              this.$emit("reload-priorities");
              this.$Notice.success({
                title: "Remove user",
                desc: "Success! ",
              });
            });
        },
      });
    },
  },
});
